import React from "react";
import DraggableFloater from "./DraggableFloater";

/**
 * TradingOrbButton — a glowing blue orb that lives on the main screen
 * and opens /trading on click. Drag-able via DraggableFloater (position
 * saved to localStorage). Owner brief: "a nice glowing orb blue button
 * that I press that is on the orb main page that will open this page".
 */
export default function TradingOrbButton() {
  return (
    <DraggableFloater
      storageKey="rawco-trading-orb-pos"
      initial={{ right: 24, bottom: 200 }}
      zIndex={45}
      testid="trading-orb-floater"
    >
      <button
        type="button"
        onClick={() => { window.location.href = "/trading"; }}
        aria-label="Open Trading"
        className="rawco-trading-orb"
        data-testid="trading-orb-btn"
      >
        <svg viewBox="0 0 100 100" width="100%" height="100%" className="rawco-trading-orb-svg">
          <defs>
            <radialGradient id="rawco-trading-grad" cx="35%" cy="30%" r="70%">
              <stop offset="0%"   stopColor="#7dd3fc"/>
              <stop offset="45%"  stopColor="#06b6d4"/>
              <stop offset="100%" stopColor="#0c4a6e"/>
            </radialGradient>
            <radialGradient id="rawco-trading-core" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgba(255,255,255,0.85)"/>
              <stop offset="60%" stopColor="rgba(125,211,252,0.0)"/>
            </radialGradient>
          </defs>

          {/* outer glow rings */}
          <circle cx="50" cy="50" r="46" fill="none"
                  stroke="rgba(34,211,238,0.35)" strokeWidth="0.8"
                  className="rawco-trading-orb-ring rawco-trading-orb-ring-1"/>
          <circle cx="50" cy="50" r="42" fill="none"
                  stroke="rgba(34,211,238,0.5)"  strokeWidth="0.6"
                  className="rawco-trading-orb-ring rawco-trading-orb-ring-2"/>

          {/* main orb */}
          <circle cx="50" cy="50" r="36" fill="url(#rawco-trading-grad)"/>
          <circle cx="50" cy="50" r="36" fill="url(#rawco-trading-core)"/>

          {/* chart line ↗ */}
          <polyline points="30,68 42,52 52,58 62,40 70,46"
                    fill="none" stroke="#ecfeff" strokeWidth="2.5"
                    strokeLinecap="round" strokeLinejoin="round"
                    style={{ filter: "drop-shadow(0 0 2px #fff)" }}/>
          <circle cx="70" cy="46" r="2.5" fill="#fff"/>

          {/* subtle pulse blob in center */}
          <circle cx="38" cy="38" r="6" fill="rgba(255,255,255,0.55)" className="rawco-trading-orb-spec"/>
        </svg>
        <div className="rawco-trading-orb-label">MARKETS</div>
      </button>

      <style>{`
        .rawco-trading-orb {
          position: relative;
          width: 64px; height: 64px;
          background: transparent;
          border: none;
          padding: 0;
          cursor: pointer;
          filter: drop-shadow(0 0 14px rgba(34,211,238,0.55))
                  drop-shadow(0 0 28px rgba(6,182,212,0.35));
          transition: filter 200ms ease, transform 200ms ease;
        }
        .rawco-trading-orb:hover {
          filter: drop-shadow(0 0 22px rgba(34,211,238,0.85))
                  drop-shadow(0 0 40px rgba(6,182,212,0.55));
          transform: scale(1.06);
        }
        .rawco-trading-orb:active { transform: scale(0.96); }
        .rawco-trading-orb-svg { display: block; }
        .rawco-trading-orb-ring {
          transform-origin: 50% 50%;
        }
        .rawco-trading-orb-ring-1 {
          animation: rawco-trading-spin 14s linear infinite;
          stroke-dasharray: 6 10;
        }
        .rawco-trading-orb-ring-2 {
          animation: rawco-trading-spin-rev 18s linear infinite;
          stroke-dasharray: 3 12;
        }
        .rawco-trading-orb-spec {
          animation: rawco-trading-pulse 2.4s ease-in-out infinite;
        }
        .rawco-trading-orb-label {
          position: absolute;
          left: 50%; bottom: -14px;
          transform: translateX(-50%);
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.15em;
          color: #67e8f9;
          text-shadow: 0 0 6px rgba(34,211,238,0.6);
          pointer-events: none;
          user-select: none;
        }
        @keyframes rawco-trading-spin     { from { transform: rotate(0); } to { transform: rotate(360deg); } }
        @keyframes rawco-trading-spin-rev { from { transform: rotate(360deg); } to { transform: rotate(0); } }
        @keyframes rawco-trading-pulse {
          0%,100% { opacity: 0.55; transform: scale(1); }
          50%     { opacity: 0.9;  transform: scale(1.18); }
        }
      `}</style>
    </DraggableFloater>
  );
}
